import React from 'react';
import { 
    Edit, 
    SimpleForm, 
    TextInput, 
    BooleanInput,
    required,
    usePermissions
} from 'react-admin';
import { FormToolbar } from "../../common/FormToolbar";
import { processPermissions } from "../../common/roleUtils";

export const ProgramEdit = props => {
    const { permissions } = usePermissions();
    let propsObj = { ...props };
    
    if (permissions) {
        // Use utility function to process permissions with role-based restrictions
        const processedPermissions = processPermissions(permissions, props.resource);
        propsObj = { ...propsObj, ...processedPermissions };
    }
    
    return (
        <React.Fragment>
            <Edit label="Edit Program" {...propsObj}>
                <SimpleForm toolbar={<FormToolbar {...propsObj} hasDelete={true}/>}>
                    <TextInput 
                        source="program_code" 
                        label='Program Code' 
                        fullWidth={true} 
                        validate={[required()]} 
                        helperText="Unique code for the program"
                    />
                    <TextInput 
                        source="program_name" 
                        label='Program Name' 
                        fullWidth={true} 
                        validate={[required()]} 
                    />
                    <TextInput 
                        source="description" 
                        label='Description' 
                        fullWidth={true} 
                        multiline 
                        rows={4}
                    />
                    <BooleanInput 
                        source="is_active" 
                        label="Active" 
                    />
                </SimpleForm>
            </Edit>
        </React.Fragment>
    );
}
